import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCountry, selectBuId, selectCurrencies, selectHasVat, selectIsFailureCountry, selectIsFetchingCountry, selectIsLoadedCountry, selectIsMandatorySubdivision, selectIsMandatoryZipCode, selectIsToRefetchCountry, selectPhonePrefix, selectSubdivisions, selectTaxes, selectTypeSubdivisions } from '@gandi/redux-places';
function fetchCountryIfNecessary(alpha2, bu) {
  return (dispatch, getState) => {
    const label = !!alpha2 && !!bu ? `${alpha2}-${bu}` : alpha2 || '';
    const state = getState();
    const shouldFetch = (!selectIsLoadedCountry(state, label) && !selectIsFailureCountry(state, label) || selectIsToRefetchCountry(state, label)) && !selectIsFetchingCountry(state, label);
    if (shouldFetch) {
      return dispatch(fetchCountry(alpha2, bu));
    }
    return Promise.resolve();
  };
}
export default function useCountry(alpha2, bu) {
  const dispatch = useDispatch();
  const label = !!alpha2 && !!bu ? `${alpha2}-${bu}` : alpha2 || '';
  const isFailureCountry = useSelector(state => selectIsFailureCountry(state, label));
  const isFetchingCountry = useSelector(state => selectIsFetchingCountry(state, label));
  const isLoadedCountry = useSelector(state => selectIsLoadedCountry(state, label));
  const isToRefetchCountry = useSelector(state => selectIsToRefetchCountry(state, label));
  const shouldFetchCountry = (!isLoadedCountry && !isFailureCountry || isToRefetchCountry) && !isFetchingCountry;
  const currencies = useSelector(state => selectCurrencies(state, label));
  const buId = useSelector(state => selectBuId(state, label));
  const isMandatorySubdivision = useSelector(state => selectIsMandatorySubdivision(state, label));
  const isMandatoryZipCode = useSelector(state => selectIsMandatoryZipCode(state, label));
  const phonePrefix = useSelector(state => selectPhonePrefix(state, label));
  const taxes = useSelector(state => selectTaxes(state, label));
  const hasVat = useSelector(state => selectHasVat(state, label));
  const subdivisions = useSelector(state => selectSubdivisions(state, label));
  const subdivisionsByType = useSelector(state => selectTypeSubdivisions(state, label));
  React.useEffect(() => {
    if (!!alpha2 && shouldFetchCountry) {
      dispatch(fetchCountryIfNecessary(alpha2, bu));
    }
  }, [alpha2, bu, dispatch, shouldFetchCountry]);
  return {
    buId,
    currencies,
    hasVat,
    isFailureCountry,
    isFetchingCountry,
    isLoadedCountry,
    isMandatorySubdivision,
    isMandatoryZipCode,
    isToRefetchCountry,
    phonePrefix: phonePrefix ? `+${phonePrefix}` : '',
    shouldFetchCountry,
    subdivisions,
    subdivisionsByType,
    taxes
  };
}